/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Progress_LabelInputs */

const en_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync progress`)
};

const fr_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression de la synchronisation`)
};

const de_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierungsfortschritt`)
};

const it_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso della sincronizzazione`)
};

const ru_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ход синхронизации`)
};

const es_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de sincronización`)
};

const zh_cn2_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步进度`)
};

const ja_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期の進行状況`)
};

const hi_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक प्रगति`)
};

const pt_pt2_sync_changes_progress_label = /** @type {(inputs: Sync_Changes_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar progresso`)
};

/**
* | output |
* | --- |
* | "Sync progress" |
*
* @param {Sync_Changes_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_progress_label = /** @type {((inputs?: Sync_Changes_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_progress_label(inputs)
	if (locale === "de") return de_sync_changes_progress_label(inputs)
	if (locale === "it") return it_sync_changes_progress_label(inputs)
	if (locale === "ru") return ru_sync_changes_progress_label(inputs)
	if (locale === "es") return es_sync_changes_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_progress_label(inputs)
	if (locale === "ja") return ja_sync_changes_progress_label(inputs)
	if (locale === "hi") return hi_sync_changes_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_progress_label(inputs)
	return en_sync_changes_progress_label(inputs)
});